import { NotificationTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";

export const NotifsReducer = (state = {}, action) => {
  switch (action.type) {
    case NotificationTypes.unset:
      return Object.assign({}, InitialState.createSyncObject());
    case NotificationTypes.read:
      let notifs = [].concat(
        state.data
      );
      
      for (let n = 0; n < notifs.length; n++) {
        if (notifs[n].notificationId === action.notification.notificationId) {
          notifs[n] = action.notification;
        }
      }
      
      return Object.assign(
        {},
        state,
        {
          data: notifs,
          lastSync: Date.now()
        }
      );
    default:
      return Object.assign({}, state, action.notifs);
  }
};
